const icoPresaleCardStyle = {
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '475px',
    height: '590px',
  },
  icoPresaleCard: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    maxWidth: '475px',
    minWidth: '475px',
  },
  pinkBG: {
    position: 'absolute',
    top: 0,
    left: '-15px',
    width: 'calc(100% + 30px)',
    height: '100%',
    borderRadius: '16px',
    backgroundImage: 'radial-gradient(54.96% 46.21% at 50.01% 50.02%, #3D0387 0%, #801EDE 100%)',
  },
  cardContent: {
    zIndex: 1,
    '@media (max-width: 768px)': {
      width: '100%',
    },
    '@media (min-width: 768px)': {
      width: 'calc(100% - 90px)',
    },
  },
  title: {
    fontFamily: 'Exo',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '36px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '1.08px',
    textTransform: 'uppercase',
    marginBottom: '10px',
    color: '#fff',
  },
  text24: {
    fontFamily: 'Exo',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '54px',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '1.08px',
    textTransform: 'uppercase',
    color: '#2E0568',
  },
  text22: {
    fontFamily: 'Source Sans Pro',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '22px',
    lineHeight: '36px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.46px',
    color: '#FFF',
  },
  text20: {
    fontFamily: 'Source Sans Pro',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    lineHeight: '28px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.46px',
    color: '#FFF',
  },
  text16: {
    fontFamily: 'Source Sans Pro',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.46px',
    color: '#FFF',
  },
  boardImageArea: {
    position: 'relative',
    width: '74px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  boardImg: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '74px',
    height: '50px',
  },
  boardContent: {
    zIndex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

export default icoPresaleCardStyle
